import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2 11.8h9.8V2.8c0-0.36-0.29-0.67-0.67-0.67H13.2v9.8z",
			style: { fill: "#4caf50" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8 11.8V2.1H2.8C2.4 2.1 2.1 2.4 2.1 2.8v9.1h9.8z",
			style: { fill: "#f44336" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8 13.2H2.1v9.1c0 0.36 0.29 0.67 0.67 0.67h9.1V13.2z",
			style: { fill: "#2196f3" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2 13.2v9.8h9.1c0.36 0 0.67-0.29 0.67-0.67V13.2H13.2z",
			style: { fill: "#ffc107" }
		})
	]
});
export default SvgMicrosoft;
